
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MeasurementSpecification, MeasurementValueType } from '../../backend/backendapi';
import { camelCase, getEnumValues } from '../../../util';

@Component
export default class TestEquipmentMeasurementSpecificationEditor extends Vue {
  @Prop({ required: true })
  readonly specification!: MeasurementSpecification;

  MeasurementValueType = MeasurementValueType; //required to be used in template, vue2 shortcoming
  camelCase = camelCase; //required to be used in template, vue2 shortcoming
  getEnumValues = getEnumValues; //required to be used in template, vue2 shortcoming

  get isFloat(): boolean {
    return this.specification.type === MeasurementValueType.Float;
  }

  get isString(): boolean {
    return this.specification.type === MeasurementValueType.String;
  }

  get specificationRequired(): boolean {
    return !this.specification.optional;
  }

  set specificationRequired(value: boolean) {
    this.specification.optional = !value;
  }

  get uid(): string {
    return this._uid;
  }
}
